import { ImgHTMLAttributes } from 'react';
import { Space, Typography } from 'antd';
import styled from 'styled-components';
import { StyledTitle } from 'components/StyledTitle';

export interface PageTitleProps extends ImgHTMLAttributes<HTMLImageElement> {
  title: string;
  subTitle?: string;
  icon: string;
  margin?: string;
}

const TitleContainer = styled(Space)<{ margin?: string }>`
  margin-bottom: ${(props) => props.margin || '16px'} !important;
`;

const { Text } = Typography;

const PageTitle = ({ title, subTitle, icon, margin, ...props }: PageTitleProps): JSX.Element => (
  <TitleContainer align="center" margin={margin}>
    <img {...props} src={icon} />
    <Space direction="vertical" size="small">
      <StyledTitle level={2}>{title}</StyledTitle>
      {subTitle && <Text type={'secondary'}>{subTitle}</Text>}
    </Space>
  </TitleContainer>
);

export default PageTitle;
